export const colorPalette = [
        "#F7C5CC", // pastel watermelon
        "#C2F9BB", // pastel light lime
        "#F8ECD1", // pastel beige
        "#F3C6E2", // pastel pink lavender
        "#F6DFEB", // pastel lilac
        "#D1CFE2", // pastel periwinkle
        "#F6C6EA", // pastel magenta
        "#E2F0CB", // pastel light green
        "#F9D5E5", // pastel blush
        "#B5EAD7", // pastel mint
        "#E0BBE4", // pastel orchid
        "#F9F9C5", // pastel lemon
        "#B5B9FF", // pastel lavender
        "#E2C2F9", // pastel purple
        "#D0F4DE", // pastel turquoise
        "#FDE2E4", // pastel coral
        "#C2F0FC", // pastel baby blue
        "#F7F6CF", // pastel butter
        "#D7E3FC", // pastel powder blue
        "#E3FDFD", // pastel ice blue
        "#FBE7C6", // pastel apricot
        "#B6E2D3", // pastel seafoam
        "#C7CEEA", // pastel blue
        "#F9C6C9", // pastel light pink
        "#FFF1B6", // pastel yellow
        "#E0F7FA", // pastel pale blue
        "#C8E6C9", // pastel mint green
        "#F6EAC2", // pastel sand
        "#FFD6E0", // pastel pink
        "#D4F1F4", // pastel aqua
        "#F3EAC2", // pastel cream
        "#A8D5BA", // pastel green
        "#D6EAF8", // pastel sky blue
        "#E4BAD4", // pastel mauve
        "#B5FFF6", // pastel cyan
        "#FFF5BA", // pastel light yellow
        "#E2F6CA", // pastel celery
        "#F7D6E0", // pastel rose
        "#C9E4DE", // pastel teal
        "#FDE2E4", // pastel coral (duplicate, but kept for 40)
        "#D9F6E6"  // pastel mint cream
    ]